export const GET_MEMBER_DASHBOARD_MAIN_DETAIL = "GET_MEMBER_DASHBOARD_MAIN_DETAIL"
export const UPDATE_MEMBER_DASHBOARD_MAIN_LOADING = "UPDATE_MEMBER_DASHBOARD_MAIN_LOADING"
export const SUBMIT_MEMBER_DASHBOARD_SUCCESS = "SUBMIT_MEMBER_DASHBOARD_SUCCESS"
export const UPDATE_MEMBER_DASHBOARD_LOADING = "UPDATE_MEMBER_DASHBOARD_LOADING"
export const UPDATE_MEMBER_DASHBOARD_PAGINATION = "UPDATE_MEMBER_DASHBOARD_PAGINATION"
export const UPDATE_MEMBER_DASHBOARD_TEMPLATE_LOADING = "UPDATE_MEMBER_DASHBOARD_TEMPLATE_LOADING"
export const UPDATE_MEMBER_DASHBOARD_TEMPLATE_LIST_DATA = "UPDATE_MEMBER_DASHBOARD_TEMPLATE_LIST_DATA"
export const UPDATE_UNIQUE_KEY = "UPDATE_UNIQUE_KEY"
export const UPDATE_KEY_DEFAULT_PARA = "UPDATE_KEY_DEFAULT_PARA"